import React, {useState} from 'react';
import {
   
    Show,
    CardActions,
    ListButton,
    SimpleShowLayout,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

import { TextField } from '@material-ui/core';
import BooleanField from '../controls/BoolNumField'



const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const EquipmentEditActions = ({props}) => (
    
    <CardActions style={cardActionStyle}>

        <ListButton basePath={'/equipregister'} label='Equipment List'/>
    </CardActions>
);

const editStyles = {
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
};

const EquipTable = ({ record }) => {
   
    console.log(record)
    return (
        <div style={{width: '100%'}}>
            <table style={{width: '100%', textAlign: 'left',fontFamily: 'arial', size: '10', color:"gray" }} cellSpacing="3" cellPadding="3">
            <tbody >
            <tr>
                <th >Gategory:</th><td>{record.name} </td>
            </tr>
            <tr>
                <th>Equipemnt ID:</th><td>{record.equip_id}</td>
            </tr>
            <tr>
                <th>Manufacturer:</th><td>{record.manufacturer}</td>
            </tr>
            <tr>
                <th>Serial Number:</th><td>{record.serial_num}</td>
            </tr>
            <tr>
                <th>Is Active?</th><td>{(record.status)? 'Yes': 'No'}</td>
            </tr>
            <tr><td colSpan="2">&nbsp;</td></tr>
            </tbody>
        </table>
        
        </div>

    )
}

const EquipmentShow =({ classes, ...props }) => (
    
<Show 
    title='Equipment View' 
    {...props}  
    actions={<EquipmentEditActions props={props}/>} 
    >
    <SimpleShowLayout >     
       <EquipTable />
    </SimpleShowLayout >     
</Show>
)
export default withStyles(editStyles)(EquipmentShow);
